"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const SIMILAR_FLEET_THRESHOLD_1 = __importDefault(require("../../../constants/app/SIMILAR_FLEET_THRESHOLD"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
const getCapacity_1 = __importDefault(require("../../utils/fleetgroup/getCapacity"));
const getPrimaryFeatures_1 = __importDefault(require("../../utils/fleetgroup/getPrimaryFeatures"));
const getTransmission_1 = __importDefault(require("../../utils/fleetgroup/getTransmission"));
/**
 * Returns formatted fleet group info
 * @param {FleetGroupType} fleetGroup
 * @param {string} language
 * @returns {FleetGroupFactoryType}
 */
function fleetGroupFactory(fleetGroup, language = LANG_1.default.EN) {
    const images = (0, get_1.default)(fleetGroup, 'images', []);
    const hasSimilarFleet = images && images.length > SIMILAR_FLEET_THRESHOLD_1.default;
    return {
        id: (0, get_1.default)(fleetGroup, 'id'),
        code: (0, get_1.default)(fleetGroup, 'code', ''),
        type: (0, get_1.default)(fleetGroup, 'type', ''),
        description: (0, get_1.default)(fleetGroup, `description.${language}`, ''),
        makeId: (0, get_1.default)(fleetGroup, 'make.id'),
        make: (0, get_1.default)(fleetGroup, `make.name.${language}`, ''),
        makeEn: (0, get_1.default)(fleetGroup, 'make.name.en', ''),
        modelId: (0, get_1.default)(fleetGroup, 'model.id'),
        model: (0, get_1.default)(fleetGroup, `model.name.${language}`, ''),
        modelEn: (0, get_1.default)(fleetGroup, 'model.name.en', ''),
        modelYear: (0, get_1.default)(fleetGroup, 'modelYear', ''),
        images,
        hasSimilarFleet,
        thumbnail: (0, get_1.default)(fleetGroup, 'thumbnail', ''),
        features: (0, get_1.default)(fleetGroup, 'features', []),
        primaryFeatures: (0, getPrimaryFeatures_1.default)((0, get_1.default)(fleetGroup, 'features', []), language),
        isEnabled: (0, get_1.default)(fleetGroup, 'isEnabled', false),
        classId: (0, get_1.default)(fleetGroup, 'class.id'),
        class: (0, get_1.default)(fleetGroup, `class.name.${language}`, ''),
        transmission: (0, getTransmission_1.default)((0, get_1.default)(fleetGroup, 'features', []), language),
        capacity: (0, getCapacity_1.default)((0, get_1.default)(fleetGroup, 'features', []), language),
    };
}
exports.default = fleetGroupFactory;
